<app-dashboard #dashboard [aggregationsType]="'visibility'">
  <app-visibility-dashboard-content
    *ngIf="dashboard.selectedFilter$ | async as selectedFilters"
    [aggregationsModel]="dashboard.aggregationsModel$ | async"
    [selectedFilters]="selectedFilters"
  >
  </app-visibility-dashboard-content>
</app-dashboard>
